import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b49634e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "categoryGrid" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "categoryLabel" }

import { ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CategorySelector',
  props: {
    categories: null,
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  categories: {
    id: string,
    label: string
  }[],
  modelValue: string[],
}



const selectedOptions = ref<string[]>([]);

onMounted(() => {
  console.log(props.modelValue);
  selectedOptions.value = [...props.modelValue];
});



const toggle = (categoryId: string) => {
  console.log(props.modelValue);

  const idx = selectedOptions.value.indexOf(categoryId);
  if (idx == -1) {
    selectedOptions.value.push(categoryId);
  } else {
    selectedOptions.value.splice(idx, 1);
  }

  emit('update:modelValue', [...selectedOptions.value]);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categories, (category) => {
      return (_openBlock(), _createElementBlock("button", {
        key: category.id,
        class: _normalizeClass(["category", {'active': selectedOptions.value.includes(category.id)}]),
        onClick: ($event: any) => (toggle(category.id))
      }, [
        _createElementVNode("img", {
          class: "categoryIcon",
          src: `/img/categoryIcons/${category.id}.png`
        }, null, 8, _hoisted_3),
        _createElementVNode("span", _hoisted_4, _toDisplayString(category.label), 1)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})